import React from "react";
import { useParams } from "react-router-dom";

import { FromPageProvider } from "../../providers/FromPageProvider";

import { PackageSeatmapWrapper } from "../../components/PackageSeatmapWrapper";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";
import { SideSheetProvider } from "../../providers/SideSheetProvider/SideSheetProvider";

export default function PackageSeatmapPage() {
  const { uuid } = useParams();

  return (
    <FromPageProvider>
      <ModalProvider>
        <SideSheetProvider>
          <PackageSeatmapWrapper uuid={uuid} />
        </SideSheetProvider>
      </ModalProvider>
    </FromPageProvider>
  );
}
